export const EDITOR_CONFIG_TYPE = {
  HEADER_LIST_SECTIONS: "header_list_sections",
  QA: "qa",
}

export const EDITOR_BLOCK_TYPE = {
  HEADER: "header",
  PARAGRAPH: "paragraph",
  LIST: "list",
}
